"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMenuOptionIdForSortable = void 0;
var getMenuOptionIdForSortable = function (option, i) {
    return option.divider ? "divider-".concat(i) : (option.label || "option-".concat(i));
};
exports.getMenuOptionIdForSortable = getMenuOptionIdForSortable;
exports.default = exports.getMenuOptionIdForSortable;
